import { cn } from '../../lib/utils';

/**
 * Brand mark.
 *
 * Inlined rather than loaded through <img> so the fill can follow
 * `currentColor` — the source asset is hardcoded white, which is invisible on
 * the light theme. Both sidebar brand blocks sit inside `text-text-1`, so the
 * mark lands on warm white in dark and warm near-black in light.
 *
 * The original file wrapped each shape in a <mask>, but all three mask rects
 * fully contain their path, so they were no-ops; dropping them avoids
 * duplicate element ids when the logo renders more than once on a page.
 * viewBox is kept at the original 1440x1440 so the glyph keeps its existing
 * optical padding and renders identically to the <img> it replaces.
 */
export function Logo({ className }: { className?: string }) {
	return (
		<svg
			viewBox="0 0 1440 1440"
			role="img"
			aria-label="05 Creation"
			fill="currentColor"
			xmlns="http://www.w3.org/2000/svg"
			className={cn('size-5 shrink-0', className)}
		>
			<path d="M1215.17 595.837C1170.89 535.402 1088.85 462.111 949.521 456.037C922.25 449.883 893.366 446.749 863.697 446.749C790.721 446.749 724.001 461.25 664.886 489.899C653.984 495.151 642.37 484.334 646.117 472.419L711.076 265.13H1267.99V252.55V248.474H713.624H650.2L547.404 576.358L509.829 696.13H575.913C591.085 647.845 616.297 604.223 649.152 568.441C682.042 532.658 722.577 504.675 768.356 487.587C813.91 470.578 867.78 459.682 931.054 459.682C937.685 459.682 943.604 459.799 949.11 460.113C1062.58 485.941 1127.66 558.995 1162.31 615.786C1212.58 698.207 1232.47 802.263 1214.19 887.39C1163.96 1121.37 963.945 1190.23 793.456 1176.63L793.005 1180.67C833.241 1187.92 871.526 1191.52 907.752 1191.52C1000.77 1191.52 1080.27 1167.69 1145.04 1120.27C1240.45 1050.43 1273.91 950.45 1285.37 897.109C1306.09 800.539 1278.55 682.295 1215.17 595.837Z" />
			<path d="M384.208 1003.1C372.949 999.907 361.756 996.068 350.676 991.563C179.563 921.976 100.172 719.659 173.369 539.666C246.567 359.671 444.624 270.183 615.739 339.768C626.819 344.275 637.513 349.338 647.804 354.91C485.085 308.814 307.416 397.99 238.955 566.336C170.493 734.684 235.501 922.547 384.208 1003.1Z" />
			<path d="M858.631 818.336C785.433 998.331 587.376 1087.82 416.261 1018.23C405.181 1013.73 394.497 1008.67 384.208 1003.1C546.915 1049.19 724.589 960 793.045 791.665C861.501 623.329 796.499 435.455 647.804 354.908C659.061 358.099 670.244 361.933 681.324 366.439C852.437 436.025 931.828 638.341 858.631 818.336Z" />
		</svg>
	);
}
